import React from "react";
import {
  SEO,
  MarkdownContent,
  Image,
  Section,
  BasicCarousel,
  ReviewV2,
} from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class ExecutiveCoachingWithKristineSingerPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={
            "https://www.solo-salon.com/executive-coaching-with-kristine-singer/"
          }
        />
        <Grid
          className={
            "custom-page-executive-coaching-with-kristine-singer custom-page-grid"
          }
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"obokkeniplhfeikm"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"pnehahfbffonebao"}
              style={{ padding: 16 }}
              width={6}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "dfe48980-c816-4e92-a8f9-b784cd80846a",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"ifdhhndagpebenkk"}
              style={{ padding: 16 }}
              width={1}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <div className={""} style={{}} />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"oefpkmhdnlbhebij"}
              style={{ padding: 16 }}
              width={5}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", backgroundSize: "cover" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "fcdc83e1-43ea-4ef4-9d27-d0f3448f1513",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"nclggigpnmlfehha"}
            style={{ padding: "100px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"cdilonlpjflgecph"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "18625bdb-d2b4-4044-9ecc-97ae5cbf4c28",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"bfpbeejikofhebhd"}
            style={{ padding: "100px", background: "#E3D5C2" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"flfmneolmbjceffm"}
              style={{ padding: 16 }}
              width={6}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "91db3e4f-da8e-4de7-9882-8b9d6e0aaea5",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"mnknojdjikeneopd"}
            style={{ padding: "100px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"mpcbjaefpghfepki"}
              style={{ padding: 16 }}
              width={6}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "68a354d0-b293-4ac0-98f2-1d927f77d053",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"ocfomcphmhhbeoob"}
            style={{ padding: 16, background: "#E3D5C2" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"blhkahmpemkkedfa"}
              style={{ padding: 16 }}
              width={16}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "1b8779d4-b3c7-43d2-884c-e8fbed16b721",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"leggjlfeoiaoegim"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"ophmikikdjbieofp"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__c192b63a-427c-490b-ba03-32073788abeb"}
                >
                  <div className={"home-page"}>
                    <Section className={"reviews-section"}>
                      <Image
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/8ef37a67-ed52-4805-a176-0da6ad2aac06/2025-04-18-10.webp"
                        }
                      >
                        <BasicCarousel
                          size={1}
                          displayIndicators={true}
                          stepSize={1}
                          autoScroll={false}
                          leftArrowIcon={"arrow-left"}
                          rightArrowIcon={"arrow-right"}
                          displayPlayPauseButton={false}
                          slide={true}
                          items={[
                            <ReviewV2 key={"1"}>
                              <ReviewV2.Text
                                charLimit={500}
                                charLimit={500}
                                text={
                                  "Working with Kristine has helped me step back and look at my business with more structure, clarity, and accountability... She has a way of balancing direct honesty with encouragement, which has helped me make difficult decisions with more confidence."
                                }
                              />
                              <ReviewV2.Line>
                                <ReviewV2.Rating rating={"5"} />
                              </ReviewV2.Line>
                              <ReviewV2.Line>
                                <ReviewV2.Author
                                  author={
                                    "Allan R. Perales, Founder, KAIN Real Estate"
                                  }
                                />
                                <ReviewV2.Source source={""} link={""} />
                              </ReviewV2.Line>
                            </ReviewV2>,
                            <ReviewV2 key={"2"}>
                              <ReviewV2.Text
                                charLimit={500}
                                charLimit={500}
                                text={
                                  "She didn't just help me grow my team by 50%. She reshaped the way I think, lead, and show up... What I'm still discovering is how much it starts with building a better version of myself first."
                                }
                              />
                              <ReviewV2.Line>
                                <ReviewV2.Rating rating={"5"} />
                              </ReviewV2.Line>
                              <ReviewV2.Line>
                                <ReviewV2.Author
                                  author={
                                    "Julio Avienda, Owner, J. Avienda Salon"
                                  }
                                />
                                <ReviewV2.Source source={""} link={""} />
                              </ReviewV2.Line>
                            </ReviewV2>,
                          ]}
                        />
                      </Image>
                    </Section>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fmmjbdchfppiefpf"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"gnebnnnoclfgehib"}
              style={{ padding: 16 }}
              width={6}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "a3ba533c-29d1-4912-aa47-993b99d0bdb6",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"joinecfjollcefid"}
              style={{ padding: 16 }}
              width={4}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", backgroundSize: "cover" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "a164d6c1-2fdd-4121-8634-9199f4ecb129",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 39353 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
  }
`;
